import { Statement } from "@mitel/cloudlink-sdk/admin";
import { PolicyTestRequest } from "@mitel/cloudlink-sdk/authentication";

export const DisableChatAccountAccessStatement: Statement =  {
	statementId: "disable-chat-account-access",
	action: [
		"*"
	],
	resource: [
		"https://mitel.io/auth/mitel-one/features/chat"
	],
	effect: "Deny" as const
}

export const DisableMeetingsAccountAccessStatement: Statement =  {
	statementId: "disable-meetings-account-access",
	action: [
		"*"
	],
	resource: [
		"https://mitel.io/auth/mitel-one/features/meet"
	],
	effect: "Deny" as const
}

export const DisableTelephonyAccountAccessStatement: Statement =  {
	statementId: "disable-telephony-account-access",
	action: [
		"*"
	],
	resource: [
		"https://mitel.io/auth/mitel-one/features/telephony"
	],
	effect: "Deny" as const
}

export const EnableCAPAccountAccessStatement: Statement =  {
	statementId: "enable-customer-admin-portal-account-access",
	action: [
		"*"
	],
	resource: [
		"https://mitel.io/auth/mivoice-business/features/customer-admin-portal"
	],
	effect: "Allow" as const
};

export const CAPFeaturePolicyTestRequest: PolicyTestRequest = {
	resources: [
		{
			resource: EnableCAPAccountAccessStatement.resource[0],
			action: "show"
		}
	]
};

export const EnableWorkflowAccessStatement: Statement = {
	statementId: 'allow-workflow-flowchanges',
	action: [
		"*"
	],
	resource: [
		"https://mitel.io/auth/wfs/features/allowWFFlowChanges"
	],
	effect: "Allow" as const
}